import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@/environments/environment';
import { Base64 } from 'js-base64';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  private endpoint: string | null;

  constructor
  (
    private httpClient: HttpClient
  ) 
  { 
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/auth/Usuarios';
  }

  obtenerUsuarios(estacion: string){
    return this.httpClient.get(this.endpoint + '/ObtenerUsuarios/'+ estacion );
  }

  crearUsuario(UsuarioRQ: any) {
    return this.httpClient.post(this.endpoint + '/AgregarUsuario', UsuarioRQ);
  }

  actualizarUsuario(UsuarioRQ: any) {
    return this.httpClient.post(this.endpoint + '/ActualizaUsuario', UsuarioRQ);
  }

  getUsersTab(idEstacion: string) {
    return this.httpClient.get(this.endpoint + '/ObtenerUsuariosTab/'+ idEstacion);
  }

  getInfoMail() {    
    return this.httpClient.get(this.endpoint + '/GetInfoMail');
  }

  getUserInfo(){
    return this.httpClient.get(this.endpoint + '/GetUserInfo/');
  }

}
